import { useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { Card } from "antd";
import placeholder_jeans from "../../img/placeholder_jeans.svg";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";

import { Pagination, Navigation, Keyboard } from "swiper";

const { Meta } = Card;

const HorizontalProducts = ({ data, isLoading, fabric, type }: any) => {
  // Use a stable, unique list of products to prevent Swiper from breaking due to duplicate keys (React reconciliation errors)
  const uniqueData = useMemo(() => {
    if (!data) return [];
    const seen = new Set();
    return data.filter((item: any) => {
      if (!item.id || seen.has(item.id)) return false;
      seen.add(item.id);
      return true;
    });
  }, [data]);

  const swiperConfig = {
    modules: [Navigation, Keyboard, Pagination],
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: true,
    keyboard: true,
 /*    pagination: {
      clickable: true,
    }, */
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 3.5,
      },
    },
    className: "mySwiper",
  };

  if (isLoading) {
    return (
      <Swiper {...swiperConfig}>
        {Array.from({ length: 4 }).map((_, i) => (
          <SwiperSlide className="d-flex flex-column skeleton_swiper" key={i}>
            <Card
              loading={true}
              bordered={false}
              style={{ width: 200 }}
              cover={
                <img
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "contain",
                  }}
                  src={placeholder_jeans}
                  alt="Loading..."
                />
              }
            >
              <Meta title="Code" description="Name" />
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
    );
  }

  if (!uniqueData || uniqueData.length === 0) {
    return null;
  }

  return (
    <div
      className={type !== "similar" ? "swiper_similar" : "swiper_similar_first"}
    ><>{console.log(uniqueData)}</>
      <h4 className="total_price_title similar_products_title">
        {type === "similar"
          ? fabric === "denim"
            ? "SAME FABRIC DIFFERENT WASH"
            : "SIMILAR PRODUCTS"
          : "TOTAL LOOK"}
      </h4>
      <Swiper {...swiperConfig}>
        {uniqueData.map((x: any) => (
          <SwiperSlide key={x.id} className="sliderHeight">
            <div style={{ textAlign: "center", width: "250px" }}>
              <Link
                to={`/product/details/${x.fabric || fabric}/${x.gendre || x.gender_id || 'unisex'}/${x.category || 'all'}/${encodeURIComponent(x.name)}/${x.id}`}
                style={{
                  textAlign: "center",
                  color: "#182844",
                }}
              >
                <img
                  src={
                    x.front_image
                      ? process.env.REACT_APP_STORAGE_URL + x.front_image
                      : placeholder_jeans
                  }
                  alt={x.name}
                  width="270"
                  height="300"
                  style={{ objectFit: 'contain' }}
                />
                <p
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                    textTransform: "capitalize",
                  }}
                >
                  {x.code} <br />
                  {x.name}
                  {x.gender_id == 2 && <>-Women</>}
                  {x.gender_id == 1 && <>-Men</>}
                  {x.gender_id == 3 && <>-Unisex</>}
                  {x.gender_id == 4 && <>-Kids</>}
                  {x.gender_id == 5 && <>-Boys</>}
                  {x.gender_id == 6 && <>-Girls</>}
                </p>
              </Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HorizontalProducts;
